import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ContactPage({ language = 'en' }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const labels = {
    en: {
      title: 'Contact Us',
      name: 'Full Name',
      email: 'Email Address',
      subject: 'Subject',
      message: 'Message',
      submit: 'Send Message',
      back: 'Back',
      success: 'Your message has been submitted!'
    },
    es: {
      title: 'Contáctanos',
      name: 'Nombre completo',
      email: 'Correo electrónico',
      subject: 'Asunto',
      message: 'Mensaje',
      submit: 'Enviar mensaje',
      back: 'Volver',
      success: '¡Tu mensaje ha sido enviado!'
    },
    pt: {
      title: 'Fale Conosco',
      name: 'Nome completo',
      email: 'Email',
      subject: 'Assunto',
      message: 'Mensagem',
      submit: 'Enviar mensagem',
      back: 'Voltar',
      success: 'Sua mensagem foi enviada!'
    }
  };

  const t = labels[language];

  const encode = (data) =>
  Object.keys(data)
    .map(k => encodeURIComponent(k) + "=" + encodeURIComponent(data[k]))
    .join("&");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  const formDataToSend = {
    "form-name": "contact",
    name: formData.name,
    email: formData.email,
    subject: formData.subject,
    message: formData.message,
  };
  try {
    await fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode(formDataToSend),
    });
    setSubmitted(true);
  } catch (err) {
    console.error("Netlify form error:", err);
    alert("There was a problem sending your message. Please try again.");
  }
};

  return (
  <>
    <section
  id="contact"
  className="bg-[#48887B] py-12 text-center scroll-mt-[120px] pt-[120px]"
>
  <h2 className="text-white text-3xl md:text-5xl font-bold">
    {t.title}
  </h2>
</section>

    <div className="max-w-3xl mx-auto py-12 px-6">
      {submitted ? (
        <p className="text-green-600 font-semibold mb-6">{t.success}</p>
      ) : (
        <form name="contact" method="POST" data-netlify="true" onSubmit={handleSubmit} className="space-y-6">
			<input type="hidden" name="form-name" value="contact" />
		<div>
            <label className="block mb-1 font-medium" htmlFor="name">{t.name}</label>
            <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full border border-gray-300 px-4 py-2 rounded-lg" />
          </div>
          <div>
            <label className="block mb-1 font-medium" htmlFor="email">{t.email}</label>
            <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full border border-gray-300 px-4 py-2 rounded-lg" />
          </div>
          <div>
            <label className="block mb-1 font-medium" htmlFor="subject">{t.subject}</label>
            <input type="text" id="subject" name="subject" required value={formData.subject} onChange={handleChange} className="w-full border border-gray-300 px-4 py-2 rounded-lg" />
          </div>
          <div>
            <label className="block mb-1 font-medium" htmlFor="message">{t.message}</label>
            <textarea id="message" name="message" required value={formData.message} onChange={handleChange} rows="5" className="w-full border border-gray-300 px-4 py-2 rounded-lg"></textarea>
          </div>
          <button type="submit" className="px-6 py-2 bg-[#48887B] text-white rounded-lg hover:bg-[#3b726a] transition">
            {t.submit}
          </button>
        </form>
      )}
      <button
        onClick={() => navigate('/')}
        className="mt-6 block px-6 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition"
      >
        {t.back}
      </button>
    </div>
  </>
);
}
